/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import useAdminPermissions from 'bundles/admin-shared/hooks/useAdminPermissions';
import PartnerSelectionButton from 'bundles/admin-v2/components/PartnerSelectionButton';
import { getAdminV2HomeRoutes } from 'bundles/admin-v2/constants/routes';
import type { Partner } from 'bundles/admin-v2/constants/types';
import Navigation from 'bundles/teach-partner-2018/components/Navigation';

type Props = {
  selectedPartnerId: number;
  selectedPartner: Partner;
  partners: Partner[] | undefined;
};

export const AdminSideNavigation: React.FC<Props> = ({ selectedPartner, selectedPartnerId, partners }) => {
  const { permissions } = useAdminPermissions();

  if (!permissions) {
    return null;
  }

  const navItems = getAdminV2HomeRoutes(permissions);

  return (
    <div
      css={{
        width: 288,
        backgroundColor: 'var(--cds-color-grey-25)',
        position: 'absolute',
        top: 65,
        overflow: 'hidden auto',
        height: '100%',
        bottom: 0,
        left: 0,
        borderRight: `1px solid var(--cds-color-grey-50)`,
      }}
      data-testid="AdminSideNavigation"
    >
      <PartnerSelectionButton
        selectedPartner={selectedPartner}
        selectedPartnerId={selectedPartnerId}
        partners={partners}
      />
      <Navigation navigationItems={navItems} />
    </div>
  );
};

export default AdminSideNavigation;
